// extracted by mini-css-extract-plugin
module.exports = {"logo":"FooterLogo_logo__6hzMg","circle":"FooterLogo_circle__BRFVK","name":"FooterLogo_name__EqOe0"};